export const filterBrokerAlgos = (data, brokers, brokersDataAll = []) => {
  const isBrokersFilter = brokers && brokers.length ? true : false;

  if (!isBrokersFilter) {
    return data;
  }

  const brokersData = [];

  const filteredBrokers = [];
  const allBrokers =
    brokersDataAll && brokersDataAll.length
      ? brokersDataAll.map((b) => b.value)
      : [];

  // check if broker exists amongst broker list
  brokers.forEach((b) => {
    if (allBrokers.includes(b)) {
      filteredBrokers.push(b);
    }
  });

  if (filteredBrokers && filteredBrokers.length) {
    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      if (!element?.broker) {
        continue;
      }

      if (filteredBrokers.includes(element?.broker)) {
        brokersData.push(element);
      }
    }
  }

  return brokersData;
};
